const defaultColumns = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: 3,
  xl: 3
}

export { defaultColumns }
